const theme = {
    colors: {
        primary: '#007bff',
        secondary: '#6c757d',
        // ... 기타 색상 설정
    },
    fonts: {
        main: "'GowunBatang', 'Apple SD Gothic Neo', 'Nanum Gothic', 'Meiryo', 'Noto Sans', sans-serif, serif, Arial",
    },
    fontSizes: {
        small: '0.8rem',
        medium: '1rem',
        large: '1.2rem',
        // ... 기타 폰트 크기 설정ㅋ
    },
    breakpoints: {
        mobile: '768px',
    },
};

export default theme;
